import {
  LockClosedIcon,
  MailIcon,
  TemplateIcon
} from '@heroicons/react/outline';
import Link from 'next/link';
import { URLS } from 'lib/constants';
import { UserIcon } from '@heroicons/react/solid';

const { passwordlessAuthentication, multifactorAuth } = URLS;

export function Benefits() {
  return (
    <div className="overflow-hidden">
      <div className="relative mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="relative lg:grid lg:grid-cols-3 lg:gap-x-8">
          <div className="lg:col-span-1">
            <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Benefits of one-time passcodes
            </h2>
          </div>
          <dl className="mt-10 space-y-10 sm:grid sm:grid-cols-2 sm:gap-x-8 sm:gap-y-10 sm:space-y-0 lg:col-span-2 lg:mt-0">
            <div key={1} className="relative">
              <dt>
                <div className="absolute flex h-12 w-12 items-center justify-center rounded-md bg-clerk-blue text-white">
                  <UserIcon className="h-6 w-6" aria-hidden="true" />
                </div>
                <p className="ml-16 text-lg font-medium leading-6 text-gray-900">
                  {'Seamless user experience'}
                </p>
              </dt>
              <dd className="mt-2 ml-16 text-left text-base text-gray-500">
                {
                  'One-time passcodes are often more secure than static passwords, but context switching between applications can be annoying for end users. Clerk enables auto-fill for SMS one-time passcodes, creating a seamless and secure mobile authentication flow.'
                }
              </dd>
            </div>
            <div key={2} className="relative">
              <dt>
                <div className="absolute flex h-12 w-12 items-center justify-center rounded-md bg-clerk-blue text-white">
                  <MailIcon className="h-6 w-6" aria-hidden="true" />
                </div>
                <p className="ml-16 text-lg font-medium leading-6 text-gray-900">
                  {'Deliverability you can count on'}
                </p>
              </dt>
              <dd className="mt-2 ml-16 text-left text-base text-gray-500">
                {
                  'Stop worrying about complex configurations and multi-level dependencies with email and SMS providers. Clerk ensures speedy delivery of SMS & email passcodes.'
                }
              </dd>
            </div>
            <div key={3} className="relative">
              <dt>
                <div className="absolute flex h-12 w-12 items-center justify-center rounded-md bg-clerk-blue text-white">
                  <TemplateIcon className="h-6 w-6" aria-hidden="true" />
                </div>
                <p className="ml-16 text-lg font-medium leading-6 text-gray-900">
                  {'Flexible implementation'}
                </p>
              </dt>
              <dd className="mt-2 ml-16 text-left text-base text-gray-500">
                <p>
                  Configuring and layering authentication methods is
                  ridiculously easy with Clerk. SMS and email passcodes are no
                  exception. They can easily be set as your primary
                  authentication method for
                  <Link legacyBehavior href={passwordlessAuthentication}>
                    <a> passwordless authentication, </a>
                  </Link>
                  or layered on for a
                  <Link legacyBehavior href={multifactorAuth}>
                    <a> multifactor authentication, </a>
                  </Link>
                  flow to strengthen security.
                </p>
              </dd>
            </div>
            <div key={4} className="relative">
              <dt>
                <div className="absolute flex h-12 w-12 items-center justify-center rounded-md bg-clerk-blue text-white">
                  <LockClosedIcon className="h-6 w-6" aria-hidden="true" />
                </div>
                <p className="ml-16 text-lg font-medium leading-6 text-gray-900">
                  {'User verification and product security  '}
                </p>
              </dt>
              <dd className="mt-2 ml-16 text-left text-base text-gray-500">
                {
                  'Create a frictionless flow for your users, while increasing resistance to bots and suspicious accounts. One-time passcodes help users effortlessly create and verify an account in one step; while increasing the friction for bad actors.'
                }
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
}
